"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RangesCalculados = void 0;
var RangesCalculados = /** @class */ (function () {
    function RangesCalculados(_a) {
        var _b = _a._id, _id = _b === void 0 ? '' : _b, _c = _a.group, group = _c === void 0 ? '' : _c, _d = _a.quantidade, quantidade = _d === void 0 ? 0 : _d, _e = _a.totalSku, totalSku = _e === void 0 ? 0 : _e, _f = _a.totalMaterial, totalMaterial = _f === void 0 ? 0 : _f, _g = _a.totalVendaDescobertaSku, totalVendaDescobertaSku = _g === void 0 ? 0 : _g, _h = _a.totalVendaDescobertaMaterial, totalVendaDescobertaMaterial = _h === void 0 ? 0 : _h, _j = _a.quantidadeMaterial, quantidadeMaterial = _j === void 0 ? 0 : _j, _k = _a.date, date = _k === void 0 ? '' : _k, _l = _a.porcentagem, porcentagem = _l === void 0 ? 0 : _l, _m = _a.porcentagemMaterial, porcentagemMaterial = _m === void 0 ? 0 : _m, _o = _a.tipoRegra, tipoRegra = _o === void 0 ? '' : _o;
        this._id = _id;
        this.group = group;
        this.quantidade = quantidade;
        this.date = date;
        this.porcentagem = porcentagem;
        this.quantidadeMaterial = quantidadeMaterial;
        this.totalSku = totalSku;
        this.totalMaterial = totalMaterial;
        this.totalVendaDescobertaSku = totalVendaDescobertaSku;
        this.totalVendaDescobertaMaterial = totalVendaDescobertaMaterial;
        this.porcentagemMaterial = porcentagemMaterial;
        this.tipoRegra = tipoRegra;
    }
    return RangesCalculados;
}());
exports.RangesCalculados = RangesCalculados;
//# sourceMappingURL=RangesCalculados.js.map